module.exports = __webpack_public_path__ + "img/payment_mb_10.a7aa2607.png";